import { useNavigate } from 'react-router-dom';
import Statistics from './Statistics';

export default function ProfileDashboard() {
  return <Statistics />;
}